import React, { Component } from 'react';
import { Provider, inject, observer } from 'mobx-react';
import {
    notificationStore,
    ContentDefinitionFormStore
} from '../../stores';
import { WithStoresComponentProps, WithStoresWrappedComponent } from '../../constants/common-types';
import { NotificationStoreModel } from '../../stores/notificationStore/notificationStoreModel';
import {
    ContentDefinitionFormStoreModel
} from '../../stores/contentDefinitionFormStore/contentDefinitionFormStoreModel';
import { ApiStoreModel } from '../../stores/apiStore/apiStore';
import
ContentDefinitionSchemaStore,
{ ContentDefinitionSchemaStoreModel } from '../../stores/ContentDefinitionEditorStore/ContentDefinitionSchemaStore';

type InjectedProps<T> = WithStoresComponentProps<T> & {
    apiStore: ApiStoreModel;
};

const withContentDefinitionFormStores = <T extends {}>(WrappedComponent: WithStoresWrappedComponent<T>) => {
    @inject('apiStore')
    @observer
    class WithContentDefinitionFormStores extends Component<WithStoresComponentProps<T>> {
        get injected() {
            return this.props as InjectedProps<T>;
        }

        notificationStore: NotificationStoreModel;
        contentDefinitionSchemaStore: ContentDefinitionSchemaStoreModel;
        contentDefinitionFormStore: ContentDefinitionFormStoreModel;

        constructor(props: WithStoresComponentProps<T>) {
            super(props);

            const { api } = this.injected.apiStore;

            this.notificationStore = notificationStore;
            this.contentDefinitionSchemaStore = new ContentDefinitionSchemaStore();
            this.contentDefinitionFormStore = new ContentDefinitionFormStore(api);
        }
        render() {
            return (
                <Provider
                    notificationStore={this.notificationStore}
                    contentDefinitionFormStore={this.contentDefinitionFormStore}
                    contentDefinitionSchemaStore={this.contentDefinitionSchemaStore}
                >
                    <WrappedComponent {...this.props} />
                </Provider>
            );
        }
    }
    return WithContentDefinitionFormStores;
};

export default withContentDefinitionFormStores;
